// extracted by mini-css-extract-plugin
export default {"chatUserAvatar":"Chat_chatUserAvatar__aYdIk","timer":"Chat_timer__6EXgu"};